let timerTax = setInterval(checkTax, 100);

function checkTax() {
    const cartTaxes = document.querySelectorAll('.cart_taxis');
    if (cartTaxes.length > 1) {
        clearInterval(timerTax);
        fetchCountryData().then((countryData) => {
            const { handle } = countryData.detected_values.country;
            if (handle === 'FI' || handle === 'fi') {
                cartTaxes.forEach((el) => el.classList.add('showTax'));
            }
        });
    } else if (cartTaxes === false) {
        clearInterval(timerTax);
    }
}

async function fetchCountryData() {
    try {
        const response = await fetch('/browsing_context_suggestions');
        const data = await response.json();
        return data;
    } catch (err) {
        console.error(err);
    }
};